import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/admin/update-partners/`;
export const Csrf = () => `/api/v3/admin/token/`;
export declare const QueryKey: never;
export type Payload = Models.Partners.Partner;
export type Response = Models.Partners.Partner;
